import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import '../Styles/Player.css';
import { invlerp, isDark, colors_salary_history } from '../Utils/colorfuncs.js'

const currency = (n) => { n = parseFloat(n); return isNaN(n) ? '—' : Number(n).toFixed(2); }

const parseDateTimeSafely = (dateStr, timeStr) => {
  if (!dateStr || !timeStr) { return null; }
  const dt = new Date(`${dateStr} ${timeStr}`);
  return isNaN(dt.getTime()) ? null : dt;
}

const formatDateTime24 = (dateStr, timeStr) => {
  const dt = parseDateTimeSafely(dateStr, timeStr);
  if (!dt) { return '—'; }
  const time = dt.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' });
  const date = dt.toLocaleDateString('en-US', { year: '2-digit', month: 'numeric', day: 'numeric' });
  return `${time} (${date})`;
}

const HistoryList = (props) => {
  const maxRows = props.maxRows || 250;

  const getSalaryStyles = (salary) => {
    const salaryNum = Number(salary);
    if (isNaN(salaryNum)) { return {}; }
    const palette = require('color-interpolate')(colors_salary_history);
    const t = invlerp(global.config.history_salary_cscale_cap_max,
                      global.config.history_salary_cscale_cap_min,
                      salaryNum);
    const bg = palette(t);
    return { backgroundColor: bg, color: isDark(bg) ? '#EEEEEE' : '#000000' };
  }

  const playersSorted = [...props.players].sort((a, b) => {
    const aDt = parseDateTimeSafely(a.date, a.time);
    const bDt = parseDateTimeSafely(b.date, b.time);
    if (aDt && bDt) { return bDt.getTime() - aDt.getTime(); }
    if (aDt && !bDt) { return -1; }
    if (!aDt && bDt) { return 1; }
    const aKey = `${a.date || ''} ${a.time || ''}`;
    const bKey = `${b.date || ''} ${b.time || ''}`;
    return aKey < bKey ? 1 : aKey > bKey ? -1 : 0;
  });

  const total = playersSorted.length;
  const rows = playersSorted.slice(0, maxRows);

  return (
    <div className="pure-u-1">
      {total > maxRows && (
        <p className="is-center"><small>Showing newest {maxRows} of {total}</small></p>
      )}
      {rows.length === 0 ? (
        <p className="is-center">No players drafted yet.</p>
      ) : (
        <div style={{ overflowX:'auto', maxWidth:1000, margin:'0 auto' }}>
          <table className="team-container pure-table pure-table-bordered history-table" style={{ width:'100%', minWidth:640, marginLeft:0, marginRight:0 }}>
            <thead>
              <tr>
                <th className="is-center">Name</th>
                <th className="is-center">Position</th>
                <th className="is-center">Team</th>
                <th className="is-center">Franchise</th>
                <th className="is-center">Salary</th>
                <th className="is-center">Date/Time</th>
              </tr>
            </thead>
            <tbody>
              <TransitionGroup component={null}>
                {rows.map((player) => (
                  <CSSTransition
                    key={`${player.nameLast}|${player.nameFirst}|${player.position}|${player.team}|${player.date}|${player.time}`}
                    timeout={1600}
                    classNames='player'
                  >
                    <tr>
                      <td>{player.name || `${player.nameLast}, ${player.nameFirst}`}</td>
                      <td className={`playerColor${player.position}`}>{player.position}</td>
                      <td>{player.team}</td>
                      <td>{player.franchise}</td>
                      <td style={getSalaryStyles(player.salary)}>${currency(player.salary)}</td>
                      <td>{formatDateTime24(player.date, player.time)}</td>
                    </tr>
                  </CSSTransition>
                ))}
              </TransitionGroup>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default HistoryList;

